<template>
    <div class="shadow-sm">
        <div class="position-relative">
            <div v-if="config.modules.stock && !product.is_product_group && product.stock !== null && product.stock <= 0"
            class="position-absolute bottom-0 end-0 m-2 p-2">
                <div class="badge rounded-pill bg-primary fw-normal">
                    {{ settings.order_out_of_stock ? t.product.restocking : t.product.out_of_stock}}
                </div>
            </div>
            <div class="position-absolute top-0 end-0">
                <wishlist-icon-component v-if="config.modules.wishlist" :data-product="product"></wishlist-icon-component>
            </div>
            <a :href="product.url">
                <img
                    :src="imageSmall(product.thumbnail)"
                    alt=""
                    class="w-100 bg-light"
                    :width="config.modules.product_image_width"
                    :height="config.modules.product_image_height"
                />
            </a>
            <promo-watermark-component :data-product="product"></promo-watermark-component>
        </div>
        <div class="p-3">
            <div class="mb-2 d-flex">
                <a class="lead fw-bold" :href="product.url">
                    {{ product.name }}
                </a>
                <span class="badge rounded-pill bg-secondary fw-normal ms-auto" v-if="product.draft">{{t.global.draft}}</span>
            </div>
            <div v-if="product.avgRate"><i class="fa-solid fa-star fa-sm"></i> {{ product.avgRate }}/{{config.reviews.rate_max_value}}</div>
            <div class="mb-2" v-if="showPrice">
                <div v-if="product.variations.length" class="fw-bold">
                    <div v-if="product.minPrice != product.maxPrice">
                        {{amountWithCurrency(product.minPrice)}} ~ {{amountWithCurrency(product.maxPrice)}}
                    </div>
                    <div v-else>{{ amountWithCurrency(product.price) }}</div>
                </div>
                <div v-else>
                    <span v-if="product.discount_price" class="text-decoration-line-through small">{{amountWithCurrency(product.public_price)}}</span>
                    <span class="fw-bold">{{ amountWithCurrency(product.price) }}</span>
                </div>
            </div>
            <add-to-cart-component :data-product="product"></add-to-cart-component>
        </div>
    </div>
</template>
<script>
import store from '../CartStore'
export default {
    props: ['dataProduct'],
    store: store,
    data() {
        return {
            t: t,
            config: config,
            settings: settings,
            product: this.dataProduct,
            showPrice: config.modules.catalog_mode === false
        };
    },
};
</script>
